// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditGroup-Main-Container {
  width: 55%;
  margin: 0 auto;
}
.EditGroup-Logo-Container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 50px;
}
.EDITGROUP-LOGO-MAIN {
  display: flex;
  align-items: center;
  gap: 16px;
}
.EditBack-Main {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  margin-top: 20px;
  margin-left: 20px;
}
.Change-owner-button {
  height: 40px;
  width: 152px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 18px;
}
.Change-owner-button:not(:disabled):hover {
  border-color: #c5ced6 !important;
  outline: none;
}
.Change-owner-text {
  color: #405261;
  line-height: 18px;
  font-size: 14px;
  font-family: "Inter";
  font-weight: 500;
}
.Edit-Back-Button {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
/* .searchGroupInput{
  width: 0%;
  flex-grow: 1;
} */
.addGroupUser_Cl01::placeholder {
  color: #c5ced6;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ChangeP01 {
  color: #148dfd;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  text-decoration-line: underline;
  cursor: pointer;
}
.EditGroup-Delete {
  border-radius: 8px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  border: none;
  padding: 11px 32px;
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.EditGroup-Delete:hover:not(:disabled) {
  background: #07c; /* lighter blue on hover */
}
.EditGroup-Delete:disabled {
  border-radius: 8px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  color: #93a1b0;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  cursor: not-allowed;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
}

.EditGroup-Active {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 128px;
  color: #405261;
  height: 40px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  font-family: "Inter";
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.Edit-Group-Main-Button {
  display: flex;
  align-items: center;
  gap: 8px;
}
.EditGroup-Input-Container {
  margin-top: 28px;
}
.AddMember-Container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
}
.EditGroup-Table-Container {
  margin-top: 34px;
}
.team-table-nameEmail {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.Active-btn-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  width: 110%;
  padding: 7px 8px;
  cursor: pointer;
}
.DeleteGroupButton {
  width: 128px;
  height: 40px;
  margin-top: 49px;
  border-radius: 8px;
  background: #ff4d4f;
  border: none;
  text-transform: none;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
  color: #fff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
  transition: background 0.3s ease, opacity 0.2s ease;
}

/* ✅ Add this hover effect */
.DeleteGroupButton:hover {
  background: #d9363e;
  color: #fff;
  opacity: 0.95;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/TeamComponents/EditGroup/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;;;GAGG;AACH;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB,EAAE,0BAA0B;AAC9C;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,6CAA6C;EAC7C,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf","sourcesContent":[".EditGroup-Main-Container {\n  width: 55%;\n  margin: 0 auto;\n}\n.EditGroup-Logo-Container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 50px;\n}\n.EDITGROUP-LOGO-MAIN {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n.EditBack-Main {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  cursor: pointer;\n  margin-top: 20px;\n  margin-left: 20px;\n}\n.Change-owner-button {\n  height: 40px;\n  width: 152px;\n  background-color: white;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin-top: 18px;\n}\n.Change-owner-button:not(:disabled):hover {\n  border-color: #c5ced6 !important;\n  outline: none;\n}\n.Change-owner-text {\n  color: #405261;\n  line-height: 18px;\n  font-size: 14px;\n  font-family: \"Inter\";\n  font-weight: 500;\n}\n.Edit-Back-Button {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n/* .searchGroupInput{\n  width: 0%;\n  flex-grow: 1;\n} */\n.addGroupUser_Cl01::placeholder {\n  color: #c5ced6;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.ChangeP01 {\n  color: #148dfd;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n  text-decoration-line: underline;\n  cursor: pointer;\n}\n.EditGroup-Delete {\n  border-radius: 8px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  border: none;\n  padding: 11px 32px;\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.EditGroup-Delete:hover:not(:disabled) {\n  background: #07c; /* lighter blue on hover */\n}\n.EditGroup-Delete:disabled {\n  border-radius: 8px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  color: #93a1b0;\n  text-align: center;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: not-allowed;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n}\n\n.EditGroup-Active {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 128px;\n  color: #405261;\n  height: 40px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  font-family: \"Inter\";\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.Edit-Group-Main-Button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.EditGroup-Input-Container {\n  margin-top: 28px;\n}\n.AddMember-Container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 20px;\n}\n.EditGroup-Table-Container {\n  margin-top: 34px;\n}\n.team-table-nameEmail {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.Active-btn-edit {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  width: 110%;\n  padding: 7px 8px;\n  cursor: pointer;\n}\n.DeleteGroupButton {\n  width: 128px;\n  height: 40px;\n  margin-top: 49px;\n  border-radius: 8px;\n  background: #ff4d4f;\n  border: none;\n  text-transform: none;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n  color: #fff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  cursor: pointer;\n  transition: background 0.3s ease, opacity 0.2s ease;\n}\n\n/* ✅ Add this hover effect */\n.DeleteGroupButton:hover {\n  background: #d9363e;\n  color: #fff;\n  opacity: 0.95;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
